export default "__VITE_ASSET__131c9c7f__"